export default "__VITE_ASSET__BJwpa_pO__"